import { Component, OnInit } from "@angular/core";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { ReportService } from "../report.service";

@Component({
	selector: "app-ms-block-list",
	templateUrl: "./ms-block-list.component.html",
	styleUrls: ["./ms-block-list.component.css"],
})
export class MsBlockListComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		SelectOptionID: 0,
		VisitorTypeID: 0,
		SortBy: "FirstName",
		SortDirection: "DESC",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	FacilityList: any = [];
	VisitorPassDetailStatusList: any = [];
	VisitorTypeList: any = [];
	VisitorStatusList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SelectOptionList: any = [
		{
			ID: 0,
			Desc: "Blocked Visitors Only",
		},
		{
			ID: 1,
			Desc: "Blocked Visitors and Allowed Offenders",
		},
		{
			ID: 2,
			Desc: "Unblocked Offenders Only",
		},
	];

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "IsBlocked",
			Desc: "Currently Blocked",
		},
		{
			ID: "Type",
			Desc: "Visitor Type",
		},
		{
			ID: "IsOffender",
			Desc: "Offender Status",
		},
		{
			ID: "VisitCount",
			Desc: "# of Visits",
		},
	];
	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 447;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.user = this.userService.getCurrentUser();

		this.loadVisitorTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadLogolist();
	}

	private loadVisitorTypeList() {
		var result = this.reportService.MsVisitorTypeSelectList();
		result.subscribe(
			(response) => {
				this.VisitorTypeList = response;

				this.VisitorTypeList.unshift({
					VisitorTypeID: -1,
					VisitorTypeDesc: "Any",
				});

				this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 448;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: IncludeAllowedOffender
		strParam += (this.report.SelectOptionID == 0 ? 0 : 1) + "|IncludeAllowedOffender";

		//Parameter 2: AllowedOffenderOnly
		strParam += "," + (this.report.SelectOptionID == 2 ? 1 : 0) + "|AllowedOffenderOnly";

		//Parameter 3: VisitorTypeID
		strParam += "," + this.report.VisitorTypeID + "|VisitorTypeID";

		//Parameter 4: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 5: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
